import { useQuery } from "@tanstack/react-query";

import { getFootprintingFarmRefrigerantUsageByPrimaryDataId, getFootprintingFarmRefrigerantUsageByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_REFRIGERANT_USAGE } from "consts";

import { FootprintingFarmRefrigerantUsage } from "models";

export const useGetFootprintingFarmRefrigerantUsage = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFootprintingFarmRefrigerantUsageByPrimaryDataIdAdmin : getFootprintingFarmRefrigerantUsageByPrimaryDataId;

  return useQuery<FootprintingFarmRefrigerantUsage[]>({
    queryKey: [FOOTPRINTING_FARM_REFRIGERANT_USAGE, primaryDataId],
    queryFn: () => queryFn(primaryDataId),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
